import axios from "axios";
import { API } from "../config/BackendUrl";

// Base URL for the API
const BASE_URL = `${API}/nft`;

// Custom Hook to interact with the NFT API
 // Function to create a new NFT
  export const createNFT = async (nftData) => {
    try {
      const response = await axios.post(`${BASE_URL}/add`, nftData);
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to like an NFT
  export const likeNFT = async (nftId, likeData) => {
    try {
      const response = await axios.post(`${BASE_URL}/${nftId}/like`, likeData);
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to Add Activity an NFT
  export const AddActivityNFT = async (nftId, activityData) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/${nftId}/activity`,
        activityData
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to NFT Listed(Mark As Listed) status an NFT
  export const ListedNFT = async (nftId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/${nftId}/list`
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to Add Auction status an NFT
  export const AuctionNFT = async (nftId, activityData) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/${nftId}/auction`,
        activityData
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to Add fractionalize(Mark As fractionalize) status an NFT
  export const AddfractionalizeNFT = async (nftId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/${nftId}/fractionalize`
      );
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to view an NFT
  export const viewNFT = async (body, nftId) => {
    try {
      const response = await axios.post(`${BASE_URL}/${nftId}/view`, body);
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to update NFT details
  export const updateNFT = async (nftId, updatedData) => {
    try {
      const response = await axios.put(`${BASE_URL}/${nftId}`, updatedData);
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  // Function to get NFT details by ID
  export const getNFT = async (nftId) => {
    console.log("NFTs", nftId, `${BASE_URL}/${nftId}`);
    
    try {
      const response = await axios.get(`${BASE_URL}/${nftId}`);
      return response.data;
    } catch (err) {
      throw err;
    }
  };

    // Function to get NFT details by ID
    export const getNFTByTokenId = async (params) => {
     
      try {
        const response = await axios.get(`${BASE_URL}/`,{
          params:params
        });
        return response.data;
      } catch (err) {
        throw err;
      }
    };

  // Function to list All NFTs 
  export const AllNFTs = async (params) => {
    try {
      const response = await axios.get(`${BASE_URL}/`);
      return response.data;
    } catch (err) {
      throw err;
    }
  };

   // Function to list NFTs with pagination and filters
   export const listNFTs = async (params) => {
    try {
      const response = await axios.get(`${BASE_URL}/`, {
        params: params,
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

   // Function to engagement
   export const EngagementNFTs = async (nftId) => {
    try {
      const response = await axios.get(`${BASE_URL}/${nftId}/engagement`);
      return response.data;
    } catch (err) {
      throw err;
    }
  };

   // Function to engagement
   export const NFTURI = async (contractAddress, nftId) => {
    try {
      const response = await axios.get(`${BASE_URL}/uri/${contractAddress}/${nftId}`);
      return response.data;
    } catch (err) {
      throw err;
    }
  };